const $ = require('jquery');
require('inputmask');
import { popupSliderTnsInit } from 'new_design/desktop/common/sliders';

$(function () {
    $('.photo.open_popup').click(function () {
        $(".tns-lazy-img").each(function() {
            const dataSrcValue = $(this).attr("data-src");
            $(this).attr("src", dataSrcValue);
        });

        popupSliderTnsInit();
        $('.photo-popup').css('display', 'block');
    })

    $('.base-services-box-row__photos .photo').each(function () {
        $(this).attr("rel", '');
    })

    $('.base-services-box-row__photos-more').hide();
    $('.service-description-truncated-open').hide();
})
